import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-empty-states',
  templateUrl: './empty-states.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./empty-states.component.scss'],
})
export class EmptyStatesComponent {
  @Input() title: string;
  @Input() subtitles: string[] = [];
  @Input() buttons: {
    text: string;
    color: string;
    params?: any[];
    action: (...args) => void;
    iconName?: string;
    iconSrc?: string;
  }[] = [];

  constructor() {}

  handleAction(action: (...args) => void, params: any[] = []) {
    action(...params);
  }
}
